import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HealthService {

  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient, private messageService: MessageService) { 

  }

  public VerifyHealth(): Observable<string> {
    return this.http.get<string>(environment.apiBaseUrl + 'health', this.httpOptions);
  }

  public SendVersionVerification(): Observable<void> {
    return this.http.post<void>(environment.apiBaseUrl + 'health/version', { version: environment.app.version }, this.httpOptions);
  }
}
